import React from "react";
import HeroSection from "../components/HeroSection";
import Contact from "../components/Contact";
import PresentationSection from "../components/About/PresentationSection";
import VisionSection from "../components/About/VisionSection";
import FounderSection from "../components/About/FounderSection";




export default function Home() {
  return (
    <div >
      <HeroSection />
      <PresentationSection style={{ marginTop: "2rem", maxWidth: "60%", margin: "2rem auto 0" }} />
      
      <Contact />
    </div>
  );
}
